import React from 'react'
import createSvgIcon from '../utilities/createSvgIcon'

export default createSvgIcon(
  <path d="M4.18945 6H2.18945V20C2.18945 21.1 3.08945 22 4.18945 22H18.1895V20H4.18945V6ZM20.1895 2H8.18945C7.08945 2 6.18945 2.9 6.18945 4V16C6.18945 17.1 7.08945 18 8.18945 18H20.1895C21.2895 18 22.1895 17.1 22.1895 16V4C22.1895 2.9 21.2895 2 20.1895 2ZM19.1895 11H9.18945V9H19.1895V11ZM15.1895 15H9.18945V13H15.1895V15ZM19.1895 7H9.18945V5H19.1895V7Z" />,
  'Files',
)
